
<template>
  <div>
    <b-row>
      <b-col cols="6">
        <div class="card">
          <div class="card-body">
            <div class="cui__utils__heading mb-0">
              <strong>Progreso de la emisión</strong>
            </div>
            <div class="text-muted">
              <p class="text-muted mb-1">Se han emitido {{ statistics.issuedEmployeePayrolls }} de {{ statistics.totalPayrolls }} nóminas</p>
              <a-progress
                  :percent="statistics.percentage"
                  status="active"
                />
            </div>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="card bg-white text-black">
          <div class="card-body" style="margin: 10px;">
            <div class="d-flex flex-wrap align-items-center">
              <i class="fa fa-calendar font-size-50 mr-3" />
              <div>
                <div class="font-size-21 font-weight-bold">Mes</div>
                <div class="font-size-15">{{ statistics.month }}</div>
              </div>
            </div>
        </div>
      </div>
      </b-col>
      <b-col>
        <div class="card bg-white text-black">
          <div class="card-body" style="margin: 10px;">
            <div class="d-flex flex-wrap align-items-center">
              <i class="fa fa-square font-size-50 mr-3" :style="{color: colorState}"/>
              <div>
                <div class="font-size-21 font-weight-bold">Estado</div>
                <div class="font-size-15">{{ statistics.state }}</div>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card bg-white text-black">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center">
              <i class="fa fa-check-square-o font-size-50 mr-3 text-success" />
              <div>
                <div class="font-size-21 font-weight-bold">Emisiones aceptadas</div>
                <div class="font-size-15">{{ statistics.payrollAccepted }}</div>
              </div>
            </div>
        </div>
      </div>
      </b-col>
      <b-col>
        <div class="card bg-white text-black">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center">
              <i class="fa fa-times-circle-o font-size-50 mr-3 text-danger" />
              <div>
                <div class="font-size-21 font-weight-bold">Emisiones por corregir</div>
                <div class="font-size-15">{{ statistics.payrollToCorrect }}</div>
              </div>
            </div>
        </div>
      </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">{{ currencyFormat(statistics.totalAccruals) }}</div>
            <div class="text-uppercase">Devengados</div>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">{{ currencyFormat(statistics.totalDeductions) }}</div>
            <div class="text-uppercase">Deducciones</div>
          </div>
        </div>
      </b-col>
      <b-col>
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="font-size-36 font-weight-bold text-dark mb-n2">{{ currencyFormat(statistics.totalPayment) }}</div>
            <div class="text-uppercase">Total pago</div>
          </div>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row>
      <b-col>
        <a-alert
        message="Información"
        description="No es posible realizar modificaciones, eliminaciones ni nuevas emisiones para una nómina que ha sido previamente enviada a la DIAN. Únicamente se permite agregar notas de ajuste o descargar el archivo XML asociado a la nómina en cuestión."
        type="info"
        show-icon
        />
      </b-col>
    </b-row> -->
    <b-row>
      <b-col offset="9" class="d-flex justify-content-end">
        <b-button @click="emitEverything()" variant="primary" class="mr-2" v-show="canEmitAll()">
          Emitir nóminas
          <i class="fa fa-download"></i>
        </b-button>
        <b-button @click="goBack()" class="btn btn-light" variant="light">
          Ir atrás
        </b-button>
      </b-col>
    </b-row>
    <br>
    <b-table hover :fields="columns" :items="data" head-variant="light" responsive>
      <template #cell(employee.salary)="payroll">
        {{ currencyFormat(payroll.item.totalPayment) }}
      </template>
      <template #cell(state)="payroll">
        <a-tag :key="payroll.item.key" :color="payroll.item.state !== 'Enviada' ? 'orange' : 'green'">
          {{ payroll.item.state.toUpperCase() }}
        </a-tag>
      </template>
      <template #cell(actions)="payroll">
        <div>
          <a-tooltip v-show="payroll.item.state === 'Enviada'" placement="top">
            <template slot="title">
              <span>Ver información</span>
            </template>
            <button type="button" class="btn btn-light mr-2" @click="viewPayroll(payroll.item)">
              <i class="fa fa-eye" />
            </button>
          </a-tooltip>
          <a-tooltip v-show="payroll.item.state !== 'Enviada' && payroll.item.typePayroll !== 'Nota de Ajuste Remover'" placement="top">
            <template slot="title">
              <span>Editar</span>
            </template>
            <span>
              <button type="button" class="btn btn-light mr-2" @click="componentPayroll(payroll.item, 'editPayrollDocument')">
                <i class="fa fa-pencil" />
              </button>
            </span>
          </a-tooltip>
          <a-tooltip v-show="payroll.item.state === 'Enviada'" placement="top">
            <template slot="title">
              <span>Nota de ajuste</span>
            </template>
            <span>
              <b-dropdown variant="light" class="mr-2" dropright no-caret>
                <template #button-content>
                  <i class="fa fa-sticky-note text-warning" />
                </template>
                <b-dropdown-item @click="componentPayroll(payroll.item, 'createAdjustmentNote')">Remplazar</b-dropdown-item>
                <b-dropdown-item @click="createDeleteNote(payroll.item)">Remover</b-dropdown-item>
              </b-dropdown>
            </span>
          </a-tooltip>
          <a-tooltip v-show="payroll.item.state !== 'Enviada'" placement="top">
            <template slot="title">
              <span>Emitir</span>
            </template>
            <span >
              <button type="button" class="btn btn-light mr-2" @click="alertEmitPayroll(payroll.item)" :disabled="payroll.item.isLoading">
                <i :class="payroll.item.isLoading ? 'fa fa-circle-o-notch fa-spin fa-1x fa-fw' : 'fa fa-paper-plane-o'" />
              </button>
            </span>
          </a-tooltip>
          <a-tooltip v-show="payroll.item.state === 'Enviada'" placement="top">
            <template slot="title">
              <span>Descargar xml</span>
            </template>
            <span>
              <button type="button" class="btn btn-light mr-2" @click="downloadXml(payroll.item.id, payroll.item.consecutive)">
                <i class="text-success-emphasis">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M14 3v4a1 1 0 0 0 1 1h4"></path><path d="M5 12V5a2 2 0 0 1 2-2h7l5 5v4M4 15l4 6m-4 0l4-6m11 0v6h3m-11 0v-6l2.5 3l2.5-3v6"></path></g></svg>
              </i>
              </button>
            </span>
          </a-tooltip>
          <a-tooltip  v-show="payroll.item.state !== 'Enviada'" placement="top">
            <template slot="title">
              <span>Eliminar</span>
            </template>
            <span>
              <button type="button" class="btn btn-light mr-2" @click="deletePayroll(payroll.item.id)">
                <i class="fa fa-trash text-danger" />
              </button>
            </span>
          </a-tooltip>
        </div>
      </template>
    </b-table>
    <b-modal ref="modalErrorsPayroll" title="Error">
      <div class="d-block" style="word-break: break-word;">
        <span><b>{{ error.message }}</b></span>
        <p class="mt-3">
          {{ error.validation }}
        </p>
      </div>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" @click="ok()">
          Ok
        </b-button>
    </template>
    </b-modal>
    <b-modal id="modalMassivePayroll" ref="modalMassivePayroll" title="Estado de le emisión">
      <div v-for="(value, key) in groupToEmit" v-bind:key="key.id" v-show="groupToEmit.length > 0">
        <b-row class="my-3 ml-auto">
          <b-col lg="15" md="15" sm="15">>
            <b>{{ value.employee.fullName }}</b>
            <i v-if="value.loading" class="fa fa-circle-o-notch fa-spin fa-1x fa-fw ml-1" />
            <a-tag class="ml-3" v-if="!value.loading" :key="key" :color="!value.error.state ? 'green' : 'red'">
              {{ (!value.error.state) ? 'Emitida' : 'Error' }}
            </a-tag>
            <b-button v-show="value.error.state" type="button"
            class="ml-1" size="sm" v-b-toggle="`collapsableErrors${value.id}`">
              <i class="mdi mdi-library-plus btn-icon-prepend"></i>
              Ver detalles
            </b-button>
          </b-col>
        </b-row>
        <b-collapse
          :id="`collapsableErrors${value.id}`"
          :accordion="`error${value.id}`"
          class="mt-1 mb-4"
          role="tabpanel"
        >
          <b-row>
            <b-col>
              <span>>>>{{ value.error.message }}</span>
            </b-col>
          </b-row>
        </b-collapse>
      </div>
    </b-modal>
    <ModalCreateEditPayroll @refreshData="refreshData" :action="payrollSelected.action" :idPayroll="payrollSelected.idPayroll"/>
    <ModalEyePayroll :idPayroll="payrollView"/>
  </div>
</template>
<script>
import apiClient2 from '@/services/axios/v2.js'
import axios from 'axios'
import { currencyFormatPesos } from '@/services/utilities'
import Swal from 'sweetalert2'
import moment from 'moment'
import ModalCreateEditPayroll from '@/components/custom/payroll/ModalCreateEditPayroll'
import ModalEyePayroll from '@/components/custom/payroll/ModalEyePayroll'
// import userPayroll from '@/components/custom/payroll'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  name: 'payrollDate',
  components: {
    ModalCreateEditPayroll,
    ModalEyePayroll,
  },
  data() {
    return {
      colorState: 'orange',
      data: [],
      error: {
        message: '',
        validation: [],
      },
      columns: [
        {
          label: 'Consecutivo',
          key: 'consecutive',
        },
        {
          label: 'Nombre',
          key: 'employee.fullName',
        },
        {
          label: 'Identificación',
          key: 'employee.cc',
        },
        {
          label: 'Valor a pagar',
          key: 'employee.salary',
        },
        {
          label: 'Estado',
          key: 'state',
        },
        {
          label: 'Acciones',
          key: 'actions',
        },
      ],
      payrollSelected: {
        idPayroll: null,
        action: '',
      },
      payrollView: null,
      statistics: {
        totalAccruals: 0,
        totalDeductions: 0,
        totalPayment: 0,
        payrollToCorrect: 0,
        payrollAccepted: 0,
        month: '',
        state: '',
        colorIconState: 'orange',
        totalPayrolls: 0,
        issuedEmployeePayrolls: 0,
        percentage: 0,
      },
      month: 0,
      year: 0,
      nominasPercent: 0,
      groupToEmit: [],
    }
  },
  beforeRouteEnter (to, from, next) {
    function getNominas() {
      return apiClient2.get(`payrolls/employees/periods?month=${to.query.month}&year=${to.query.year}`)
    }

    axios.all([getNominas()])
      .then(axios.spread(function (nominas) {
        next((vm) => {
          vm.setDataNominas(null, nominas.data.data)
          vm.setNominaDate(to.query.month, to.query.year)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataNominas(err, [])
          vm.setNominaDate(to.query.month, to.query.year)
        })
      })
  },
  created() {
    apiClient2.get('payrolls/periods', {
      params: {
        month: this.$route.query.month,
        year: this.$route.query.year,
      },
    }).then((res) => {
      if (res.data.success) {
        const [data] = res.data.data
        // console.log('DATA', data)
        this.statistics.payrollToCorrect = data.toCorrect
        this.statistics.payrollAccepted = data.issued
        this.statistics.month = this.getNameMonth(data.month)
        if (data.state === 'Enviada') {
          this.colorState = 'green'
        }
        this.statistics.state = data.state
        this.statistics.totalPayrolls = (Number(data.totalPayrolls) + Number(data.totalAdjustmentNotes))
        this.statistics.issuedEmployeePayrolls = data.issued
        this.statistics.percentage = Number(((Number(data.issued) / (Number(data.totalPayrolls) + Number(data.totalAdjustmentNotes))) * 100).toFixed(0))
      } else {
        alert('Hubo un error en el servidor al traer las estadísticas!')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  methods: {
    goBack() {
      this.$router.push('/payrolls/periods')
    },
    saveData() {
      this.$refs.modalEditPayroll.hide()
    },
    emitEverything() {
      const amountToSend = (this.data.filter((e) => e.state !== 'Enviada')).length
      Swal.fire({
        title: 'Confirmar emisión',
        text: `¿Estás seguro de emitir ${amountToSend} ${(amountToSend === 1) ? 'nómina' : 'nóminas'}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, emitir',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.groupToEmit = []
          this.$bvModal.show('modalMassivePayroll')
          let index = 0
          for (const payroll of this.data) {
            this.groupToEmit.push({
              ...payroll,
              loading: true,
              error: {
                state: false,
              },
            })
            apiClient2.post('payrolls/dian', { payrolls: [payroll.id] }).then(response => {
              const { data } = response
              if (data.success) {
                payroll.isLoading = false
                const { data: dataRes } = data
                if (dataRes[0].wasSentDian) {
                  // La nómina-nota fue enviada exitosamente 🎉
                  Toast.fire({
                    icon: 'success',
                    title: dataRes[0].message,
                  })
                  this.groupToEmit[index].loading = false
                } else {
                  // Hubo problemas al enviar la nómina-nota ✖️
                  this.groupToEmit[index].error.state = true
                  this.groupToEmit[index].error.validation = dataRes[0].statusCode
                  this.groupToEmit[index].error.message = dataRes[0].message
                  this.groupToEmit[index].loading = false
                }
                index += 1
              }
              payroll.isLoading = false
              this.refreshData()
            }).catch(error => {
              payroll.isLoading = false
              const { data: dataRes } = error.response
              this.groupToEmit[index].error.state = true
              this.groupToEmit[index].error.validation = dataRes.statusCode
              this.groupToEmit[index].error.message = dataRes.error.message
              this.groupToEmit[index].loading = false
              index += 1
            })
          }
        }
      })
    },
    getNameMonth(month) {
      const months = [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ]
      return months[month - 1]
    },
    formattedDate() {
      const date = new Date('1/' + this.month + '/' + this.year).toLocaleDateString('en-GB')
      return moment(date).locale('es').format('MMMM YYYY')
    },
    currencyFormat: function (money) {
      return currencyFormatPesos(money)
    },
    canEmitAll() {
      return (this.data.filter((e) => e.state !== 'Enviada')).length > 0
    },
    viewPayroll(payroll) {
      this.payrollView = payroll.id
      this.$bvModal.show('modal-view-payroll')
    },
    componentPayroll(payroll, action) {
      this.payrollSelected.action = action
      this.payrollSelected.idPayroll = payroll.id
      this.$bvModal.show('modal-payroll')
    },
    setDataNominas(err, data) {
      if (err) {
        this.error = err.toString()
      } else {
        this.data = data.payrolls.map((d) => {
          return { ...d, isLoading: false }
        })
        this.statistics.totalAccruals = data.totals.totalAccruals
        this.statistics.totalDeductions = data.totals.totalDeductions
        this.statistics.totalPayment = data.totals.totalPayment
      }
    },
    setNominaDate(month, year) {
      this.month = month
      this.year = year
    },
    alertEmitPayroll(payroll) {
      Swal.fire({
        title: 'Confirmar emisión',
        text: `¿Estás seguro de emitir la ${payroll.typePayroll} de ${payroll.employee.fullName}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, enviar',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          payroll.isLoading = true
          apiClient2.post('payrolls/dian', { payrolls: [payroll.id] }).then(response => {
            const { data } = response
            if (data.success) {
              payroll.isLoading = false
              const { data: dataRes } = data
              if (dataRes[0].wasSentDian) {
                // La nómina-nota fue enviada exitosamente 🎉
                Toast.fire({
                  icon: 'success',
                  title: dataRes[0].message,
                })
              } else {
                // Hubo problemas al enviar la nómina-nota ✖️
                this.error.validation = dataRes[0].message
                this.error.message = `Error al emitir la ${payroll.typePayroll} a la DIAN!`
                this.$refs.modalErrorsPayroll.show()
              }
            }
            payroll.isLoading = false
            this.refreshData()
          }).catch(error => {
            payroll.isLoading = false
            console.log(error)
            // Toast.fire({
            //   icon: 'warning',
            //   title: 'Ooops ocurrió un error',
            // })
          })
        }
      })
    },
    closeModal() {
      this.payrollDataSent.idsPayroll = []
      // console.log('se hizo')
    },
    refreshData() {
      // Refresca la data de la tabla
      apiClient2.get(`payrolls/employees/periods?month=${this.month}&year=${this.year}`).then((res) => {
        this.setDataNominas(null, res.data.data)
      }).catch(e => {
        console.log(e)
      })
      // Refresca la data de las estadísticas
      apiClient2.get('payrolls/periods', {
        params: {
          month: this.$route.query.month,
          year: this.$route.query.year,
        },
      }).then((res) => {
        if (res.data.success) {
          const [data] = res.data.data
          this.statistics.payrollToCorrect = data.toCorrect
          this.statistics.payrollAccepted = data.issued
          this.statistics.month = this.getNameMonth(data.month)
          if (data.state === 'Enviada') {
            this.colorState = 'green'
          } else {
            this.colorState = 'orange'
          }
          this.statistics.state = data.state
          this.statistics.totalPayrolls = (Number(data.totalPayrolls) + Number(data.totalAdjustmentNotes))
          this.statistics.issuedEmployeePayrolls = data.issued
          this.statistics.percentage = Number(((Number(data.issued) / (Number(data.totalPayrolls) + Number(data.totalAdjustmentNotes))) * 100).toFixed(0))
        } else {
          alert('Hubo un error en el servidor al traer las estadísticas!')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    downloadXml(idPayroll, consecutive) {
      apiClient2.get(`payrolls/${idPayroll}/xml`).then((res) => {
        const xml = res.data || ''
        const blob = new Blob([xml], { type: 'application/xml' })
        // Crear un enlace de descarga
        var link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = `nomina-${consecutive}-eroo.xml`
        // Agregar el enlace al cuerpo del documento
        document.body.appendChild(link)
        // Simular un clic en el enlace para iniciar la descarga
        link.click()
        // Eliminar el enlace del cuerpo del documento
        document.body.removeChild(link)
      }).catch(e => {
        console.log(e)
      })
    },
    deletePayroll(idPayroll) {
      apiClient2.delete(`payrolls/${idPayroll}`).then((res) => {
        // console.log(res)
        if (res.data.success) {
          Toast.fire({
            icon: 'success',
            title: res.data.message,
          })
          this.refreshData()
        } else {
          alert('Error al borrar la nómina, comunicate con soporte')
        }
      }).catch(e => {
        console.log(e)
      })
    },
    hideModal() {
      this.$refs.modalErrorsPayroll.hide()
    },
    getPayroll(idPayroll) {
      return new Promise((resolve, reject) => {
        // Trae la información de la nómina o nota de ajuste
        apiClient2.get(`payrolls/${idPayroll}`).then((res) => {
          const { data } = res
          const payrollData = {
            employee: {},
          }
          if (data.success) {
            const { data: payroll } = data;
            ['payStartDate', 'payEndDate', 'payDate', 'consecutive', 'accruals', 'deductions', 'totals'].forEach((k) => {
              payrollData[k] = payroll[k]
            })
            payrollData.employee = payroll.employee
          }
          resolve(payrollData)
        }).catch((err) => {
          reject(err)
        })
      })
    },
    sendDeleteNote(idPayroll, data) {
      return new Promise((resolve, reject) => {
        // console.log('idPayroll', idPayroll, 'data', data)
        apiClient2.post(`payrolls/${idPayroll}/adjustment-note`, data).then(response => {
          // console.log(response)
          const { data } = response
          // console.log('DATA', data)
          if (data.success) {
            Toast.fire({
              icon: 'success',
              title: data.message,
            })
          }
          this.refreshData()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    createDeleteNote(payroll) {
      // console.log('payroll adsfasd', payroll)
      Swal.fire({
        title: 'Nota de Ajuste Remover',
        text: '¿Estás seguro de crear una nota de ajuste remover?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, crear',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.getPayroll(payroll.id)
            .then((dataPayroll) => {
              const data = {
                payStartDate: moment(dataPayroll.payStartDate).utc().format('YYYY-MM-DD'),
                payEndDate: moment(dataPayroll.payEndDate).utc().format('YYYY-MM-DD'),
                payDate: moment(dataPayroll.payDate).utc().format('YYYY-MM-DD'),
                typePayroll: 'Nota de Ajuste Remover',
                accruals: dataPayroll.accruals.map((a) => {
                  return {
                    idConcept: a.idConcept,
                    ...((a.percentage !== null && a.percentage !== '') && { percentage: Number(a.percentage) }),
                    ...((a.value !== null && a.value !== '') && { value: Number(a.value) }),
                    ...((a.hours !== null && a.hours !== '') && { hours: Number(a.hours) }),
                    ...((a.days !== null && a.days !== '') && { days: Number(a.days) }),
                  }
                }),
                deductions: dataPayroll.deductions.map((a) => {
                  return {
                    idConcept: a.idConcept,
                    ...((a.percentage !== null && a.percentage !== '') && { percentage: Number(a.percentage) }),
                    ...((a.value !== null && a.value !== '') && { value: Number(a.value) }),
                    ...((a.hours !== null && a.hours !== '') && { hours: Number(a.hours) }),
                    ...((a.days !== null && a.days !== '') && { days: Number(a.days) }),
                  }
                }),
              }
              const idPayrollSend = payroll.idPayroll === null ? payroll.id : payroll.idPayroll
              this.sendDeleteNote(idPayrollSend, data)
            })
            .catch(err => console.log(err))
        }
      })
    },
  },
}
</script>
<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
